import './styles/css/index.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { createRoot } from 'react-dom/client';

import App from './App';

async function startWorker() {
  const { worker } = await import('./mocks/browser');
  return worker.start();
}

const container = document.getElementById('root');
const root = createRoot(container);

async function render() {
  if (import.meta.env.VITE_APP_ENABLE_MSW === 'true') {
    await startWorker();
  }
  root.render(<App />);
}

render();
